import { Link } from '@egw/components'
import { ChevronRightIcon, ArrowDownTrayIcon } from '@heroicons/react/24/solid'
import { type FC } from 'react'

export enum ListLinkEnum {
  LINK,
  DOWNLOAD,
}

interface ListLinkProps {
  to: string
  title: string
  variant?: ListLinkEnum
  isLast?: boolean
}

export const ListLink: FC<ListLinkProps> = ({ to, title, variant = ListLinkEnum.LINK, isLast = false }) => {
  return (
    <Link
      className={`text-base text-body flex w-full justify-between items-center text-body text-base font-normal border-light group w-full rounded-none ${isLast ? '' : 'border-b'} py-4 transition-all duration-200 cursor-pointer`}
      href={to}
    >
      {title}
      {variant === ListLinkEnum.LINK && (
        <ChevronRightIcon className="fill-iconmuted md:group-hover:fill-iconfull h-5 w-5 stroke-none flex-shrink-0" />
      )}
      {variant === ListLinkEnum.DOWNLOAD && (
        <ArrowDownTrayIcon
          className="fill-blue-500 h-5 w-5 group-hover:fill-blue-700 flex-shrink-0"
          height={20}
          width={20}
        />
      )}
    </Link>
  )
}
